import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const PlusIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    boxSize="24px"
    data-testid="plus icon"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 17V7M7 12h10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </Icon>
);
